import React from 'react';
import { Box, Divider, Paper } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import useGetRequest from 'src/hooks/useGetRequest';
import useModal from 'src/components/Modal/useModal';
import Button from 'src/components/Button';
import { sendEmailForEngagement, dismissTask } from 'src/utils/api';
import { Skeleton } from '@material-ui/lab';
import PreviewEmail from '../../emails/PreviewEmail';
import EditEmail from '../../emails/EditEmail';
import EmailLoader from '../../emails/EmailLoader';

const SendEmailHandlerContent = ({
  recipients: _recipients,
  ccs: _ccs,
  bccs: _bccs,
  subject: _subject,
  body: _body,
  engagementId,
  task,
  onSuccess,
  setIsSending
}: any) => {
  const [recipients, setRecipients] = React.useState(_recipients);
  const [ccs, setCcs] = React.useState(_ccs);
  const [bccs, setBccs] = React.useState(_bccs);
  const [subject, setSubject] = React.useState(_subject);
  const [body, setBody] = React.useState(_body);
  const { isOpen, openModal, closeModal } = useModal();
  const { enqueueSnackbar } = useSnackbar();

  const handleSend = () => {
    setIsSending(true);
    sendEmailForEngagement(engagementId, {
      recipients: recipients.map((recipient: any) => recipient.email),
      subject,
      body,
      completedTaskId: task.id,
    }).then(() => onSuccess('Email sent.')).finally(() => setIsSending(false));
  };

  const handleDismiss = () => {
    dismissTask(engagementId, task.id).then(() => onSuccess('Task dismissed.'))
      .catch(() => {
        enqueueSnackbar('There was an issue dismissing this task', {
          variant: 'error'
        });
      });
  };

  const editor = (
    <EditEmail
      engagementId={engagementId}
      onClose={closeModal}
      recipients={recipients}
      ccs={ccs}
      bccs={bccs}
      subject={subject}
      body={body}
      setRecipients={setRecipients}
      setCcs={setCcs}
      setBccs={setBccs}
      setSubject={setSubject}
      setBody={setBody}
    />
  );

  // todo - don't show both modals at one time
  return (
    <Box height="100%" flexDirection="column" flexGrow="1">
      {isOpen && editor}
      <PreviewEmail
        recipients={recipients}
        ccs={ccs}
        bccs={bccs}
        subject={subject}
        body={body}
      />
      <Box display="flex" mt={2} justifyContent="space-between">
        {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: string; onClick: () => void; }' ... Remove this comment to see the full error message */}
        <Button onClick={handleDismiss}>
          Dismiss
        </Button>
        <Box display="flex">
          {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: string; onClick: () => void; }' ... Remove this comment to see the full error message */}
          <Button onClick={() => openModal()}>
            Edit
          </Button>
          <Box ml={2}>
            {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: string; look: string; onClick: (... Remove this comment to see the full error message */}
            <Button look="primary" onClick={handleSend}>
              Send
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const SendEmailHandler = ({
  engagementId,
  triggeredAction,
  onSuccess,
  task
}: any) => {
  const { result: email, isLoading: emailIsLoading } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/preview-email/${triggeredAction.action.emailTemplate.id}/`,
  });
  const [isSending, setIsSending] = React.useState(false);

  if (emailIsLoading || isSending) return <EmailLoader />;

  return (
    <SendEmailHandlerContent
      recipients={email.recipients}
      sender={email.sender}
      ccs={email.ccs}
      bccs={email.bccs}
      subject={email.subject}
      body={email.body}
      engagementId={engagementId}
      onSuccess={onSuccess}
      task={task}
      setIsSending={setIsSending}
    />
  );
};

export default SendEmailHandler;
